import { createFileRoute } from "@tanstack/react-router";

import DeleteLastRoundScorePage from "~/pages/game/DeleteLastRoundScorePage.tsx";

export const Route = createFileRoute("/_auth/game-session/$gameSessionId/games/$gameId/rounds/delete")({
    component: DeleteLastRoundScorePage,
});
